import {
    Button,
    Card,
    Checkbox,
    DatePicker,
    Form,
    Input,
    InputNumber,
    Radio,
    Select,
    Skeleton,
    Upload,
    message
} from "antd";
import React, { useEffect, useState } from "react";
import { LoadingOutlined, UploadOutlined } from "@ant-design/icons";
import { GoogleMap, LoadScript, MarkerF } from '@react-google-maps/api';
import SearchMap from "./SearchMap";
import OTPInput, { ResendOTP } from "otp-input-react";
import WidgetInventia from "./WidgetInventia";
import { CONFIG } from '../services/config';
import CI from "./../assets/img/CI.jpg"
import CIE from "./../assets/img/CIE.jpg"
import CIE3 from "./../assets/img/CIE3.jpg"
import pass from "./../assets/img/pass.jpg"
import pat from "./../assets/img/pat.jpg"
import { ReactComponent as SvgCie3 } from "./../assets/svg/SvgCie3.svg";
import { getDinamico, postDinamico, searchValue } from "../services/api";
import { useNavigate } from "react-router";
import DialogInattività from "../pages/DialogInattività";
const { innerWidth, innerHeight } = window;

const FormOnboarding = ({ regole, headerSezione, loading, setSezioneCompiled, loadingSetSezioni, setFile }) => {
    const navigate = useNavigate();
    const [buttons, setButtons] = useState();
    const [checkbox, setCheckbox] = useState([]);
    const [coord, setCoord] = useState({ lat: 44.390789, lng: 7.820823 });
    const [loadingApi, setLoadingApi] = useState();
    const [locationFields, setLocationFields] = useState([]);
    const [fileUpload, setFileUpload] = useState([]);
    const [caseApiValue, setCaseApiValue] = useState();
    const [hideButton, setHideButton] = useState();
    const [pickedDate, setPickedDate] = useState();
    const [condizione, setCondizione] = useState({});
    const [visibilita, setVisibilita] = useState({});
    const [cardColor, setCardColor] = useState({});
    const [emptyCheckbox, setEmptyCheckbox] = useState([]);
    const [isTotem, setIsTotem] = useState(false);
    const [secondsTimeout, setSecondsTimeout] = useState(0);
    const [showDialogInattivita, setShowDialogInattivita] = useState(false);
    const [timeoutInCorso, setTimeoutInCorso] = useState(false);
    const [searchValues, setSearchValues] = useState([]);


    const formRef = React.createRef();

    const center = {
        lat: coord.lat,
        lng: coord.lng
    }

    useEffect(() => {
        if (localStorage.getItem('praticaTotem')) {
            setIsTotem(true);
            if (!timeoutInCorso) {
                startTimeout();
                setTimeoutInCorso(true);
            }
        }
        setHideButton(false);
        setButtons();
        setCondizione({});
        setCheckbox([]);
        setEmptyCheckbox([]);
        localStorage.removeItem('campo_map');
        setFileUpload();
        regole.forEach((item) => {
            if (item.validazione == 'buttons') {
                setHideButton(true);
            }
            if (item.validazione == 'inventia') {
                setHideButton(true);
            }
            if (item.campo_visibilita) {
                const cond = condizione;
                condizione[JSON.parse(item.campo_visibilita).campo] = { valore: JSON.parse(item.campo_visibilita).valore, campoVis: item.campo };
                setCondizione(cond);
            }
            if (item.validazione == 'checkbox') {
                localStorage.removeItem(item.campo);
                const c = emptyCheckbox;
                c.push(item.campo);
                setEmptyCheckbox(c);
            }
        });
    }, [regole])

    useEffect(() => {
        if (locationFields.length > 0) {
            const indirizzo = locationFields.filter((item) => {
                if (item.types[0] == 'route') {
                    return item.long_name;
                }
            });
            if (indirizzo[0]) {
                formRef.current.setFieldsValue({
                    indirizzo: indirizzo[0].long_name,
                })
            }

            const civico = locationFields.filter((item) => {
                if (item.types[0] == 'street_number') {
                    return item.long_name;
                }
            });
            if (civico[0]) {
                formRef.current.setFieldsValue({
                    civico: civico[0].long_name,
                })
            }

            const provincia = locationFields.filter((item) => {
                if (item.types[0] == 'administrative_area_level_2') {
                    return item.long_name;
                }
            });
            if (provincia[0]) {
                formRef.current.setFieldsValue({
                    provincia: provincia[0].short_name,
                })
            }
            const citta = locationFields.filter((item) => {
                if (item.types[0] == 'administrative_area_level_3') {
                    return item.long_name;
                }
            });
            if (citta[0]) {
                formRef.current.setFieldsValue({
                    citta: citta[0].long_name,
                })
            }
            const cap = locationFields.filter((item) => {
                if (item.types[0] == 'postal_code') {
                    return item.long_name;
                }
            });
            if (cap[0]) {
                formRef.current.setFieldsValue({
                    cap: cap[0].long_name,
                })
            }
            if (coord) {
                formRef.current.setFieldsValue({
                    lat: coord.lat,
                    lng: coord.lng
                })
            }
        }
    }, [coord])

    const startTimeout = () => {
        setSecondsTimeout(CONFIG.TOTEM_TIMEOUT_SECONDS);
        const alert = CONFIG.TOTEM_TIMEOUT_SECONDS_ALERT

        const interval = setInterval(() => {
            setSecondsTimeout(prevSeconds => {
                if (prevSeconds === 0) {
                    clearInterval(interval);
                    localStorage.removeItem('praticaTotem');
                    navigate('/homepage', { state: { isTotem: true } })
                    return 0;
                }

                if ((prevSeconds - 1) == alert) {
                    setShowDialogInattivita(true);
                }
                return prevSeconds - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }

    const sezioneHandler = (value) => {
        const mapCampo = localStorage.getItem('campo_map');
        if (buttons) {
            value[buttons.campo] = buttons.valore
            // setButtons(); // se c'è errore nella chiamata non bisogna cancellare dati per riprovare o si aggiorna la pagina
        }
        if (checkbox.length > 0) {
            checkbox.forEach((item) => {
                const checkArray = JSON.parse(localStorage.getItem(item));
                if (checkArray && checkArray.length > 0) {
                    checkArray.forEach((i) => {
                        if (i.campo) {
                            const v = document.getElementById(i.id);
                            i[i.campo] = v.value;
                            delete i.campo;
                            delete i.id;
                        }
                    });
                    value[item] = checkArray;
                } else {
                    value[item] = [];
                }
            });
        }
        if (fileUpload) {
            setFile(fileUpload);
        }
        if (mapCampo) {
            let c = {};
            c = {
                indirizzo: value.indirizzo,
                civico: value.civico,
                provincia: value.provincia,
                citta: value.citta,
                cap: value.cap,
                lat: value.lat,
                lng: value.lng
            };
            delete value.indirizzo;
            delete value.civico;
            delete value.provincia;
            delete value.citta;
            delete value.cap;
            delete value.lat;
            delete value.lng;
            value[mapCampo] = c;
            // localStorage.removeItem('campo_map');
        }
        if (caseApiValue && caseApiValue.value) {
            value[caseApiValue.nomeCampo] = caseApiValue.value;
        }
        for (const key in value) {
            if (value[key] == undefined) {
                if (emptyCheckbox.includes(key)) {
                    value[key] = [];
                }
            }
        }
        setSezioneCompiled(value);
    };

    const generateItems = function () {
        let rows = [];
        let lastOrdine = 0;
        let data = [];

        for (var i = 0; i < regole.length; i++) {
            if (lastOrdine !== regole[i].ordine) {
                lastOrdine = regole[i].ordine;
                rows.push(
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        {data}
                    </div>
                )
                data = [];
            }

            data.push(
                <div style={{ display: regole[i].validazione != 'hidden' ? 'flex' : 'none', flexDirection: 'column', flex: 1 }}>
                    {getItemByValidazione(regole[i])}
                </div>
            );

            
        }

        if (data != []) {
            rows.push(
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {data}
                </div>
            )
        }

        return rows;
    }

    const getItemByValidazione = function (regola) {
        switch (regola.validazione) {
            case "string":
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <>
                                <Form.Item
                                    name={regola.campo}
                                    key={regola.ordine}
                                    label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium' }}>{regola.etichetta}</div>}
                                    initialValue={regola.value != null ? regola.value : ""}
                                    // style={{ width: innerWidth < 500 ? '80%' : '60%', marginBottom: 50 }}
                                    style={{ width: '80%', marginBottom: 50 }}

                                    rules={[
                                        {
                                            required: regola.flg_not_required ? false : true,
                                            message: 'Questo campo è obbligatorio',
                                        },
                                    ]}
                                >
                                    <Input autoComplete={isTotem ? 'off' : 'on'} disabled={regola.flg_readonly ? true : false} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                </Form.Item>
                                {regola.etichetta_conferma != null &&
                                    <Form.Item
                                        name={`${regola.campo}Verifica`}
                                        key={`${regola.ordine}Verifica`}
                                        initialValue={regola.value != null ? regola.value : ""}
                                        label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', marginBottom: 20 }}>{regola.etichetta_conferma}</div>}
                                        rules={[
                                            {
                                                required: regola.flg_not_required ? false : true,
                                                message: 'Questo campo è obbligatorio',
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue(regola.campo) === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        new Error("I due campi non corrispondono")
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input autoComplete={isTotem ? 'off' : 'on'} disabled={regola.flg_readonly ? true : false} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                    </Form.Item>
                                }
                            </>
                        }
                    </>
                );
            case "phone":
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <>
                                <Form.Item
                                    name={regola.campo}
                                    key={regola.ordine}
                                    label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', marginBottom: 20 }}>{regola.etichetta}</div>}
                                    initialValue={regola.value != null ? regola.value : "+39"}
                                    // style={{ width: innerWidth < 500 ? '80%' : '50%', marginBottom: 50 }}
                                    style={{ width: '80%', marginBottom: 50 }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Questo campo è obbligatorio',
                                        },
                                    ]}
                                >
                                    <Input autoComplete={isTotem ? 'off' : 'on'} placeholder="+39**********" controls={false} style={{ borderWidth: 0, width: '100%', borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                </Form.Item>
                                {regola.etichetta_conferma != null &&
                                    <Form.Item
                                        name={`${regola.campo}Verifica`}
                                        key={`${regola.ordine}Verifica`}
                                        initialValue={regola.value != null ? regola.value : "+39"}
                                        style={{ width: '80%', marginBottom: 50 }}
                                        label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', marginBottom: 20 }}>{regola.etichetta_conferma}</div>}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Questo campo è obbligatorio',
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue(regola.campo) === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        new Error("I due campi non corrispondono")
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input autoComplete={isTotem ? 'off' : 'on'} placeholder="+39**********" controls={false} style={{ borderWidth: 0, borderBottomWidth: 1, width: '100%', borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                    </Form.Item>
                                }
                            </>
                        }
                    </>
                );
            case "email":
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <>
                                <Form.Item
                                    name={regola.campo}
                                    key={regola.ordine}
                                    label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', marginBottom: 20 }}>{regola.etichetta}</div>}
                                    initialValue={regola.value != null ? regola.value : ""}
                                    style={{ width: '80%', marginBottom: 50 }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Questo campo è obbligatorio',
                                            type: 'email'
                                        },
                                    ]}
                                >
                                    <Input autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, width: '100%', borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                </Form.Item>
                                {regola.etichetta_conferma != null &&
                                    <Form.Item
                                        name={`${regola.campo}Verifica`}
                                        key={`${regola.ordine}Verifica`}
                                        initialValue={regola.value != null ? regola.value : ""}
                                        style={{ width:'80%', marginBottom: 50 }}
                                        label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', marginBottom: 20 }}>{regola.etichetta_conferma}</div>}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Questo campo è obbligatorio',
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue(regola.campo) === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        new Error("I due campi non corrispondono")
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, width: '100%', borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                    </Form.Item>
                                }
                            </>
                        }
                    </>
                );
            case "number":
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <>
                                <Form.Item
                                    name={regola.campo}
                                    key={regola.ordine}
                                    label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium' }}>{regola.etichetta}</div>}
                                    initialValue={regola.value != null ? regola.value : ""}
                                    style={{ width: '80%', marginBottom: 50 }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Questo campo è obbligatorio',
                                        },
                                    ]}
                                >
                                    <Input autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                </Form.Item>
                                {regola.etichetta_conferma != null &&
                                    <Form.Item
                                        name={`${regola.campo}Verifica`}
                                        key={`${regola.ordine}Verifica`}
                                        initialValue={regola.value != null ? regola.value : ""}
                                        label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', marginBottom: 20 }}>{regola.etichetta_conferma}</div>}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Questo campo è obbligatorio',
                                                type: 'number'
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue(regola.campo) === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        new Error("I due campi non corrispondono")
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                    </Form.Item>
                                }
                            </>
                        }
                    </>
                );
            case "only_number":
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <>
                                <Form.Item
                                    name={regola.campo}
                                    key={regola.ordine}
                                    label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium' }}>{regola.etichetta}</div>}
                                    initialValue={regola.value != null ? regola.value : ""}
                                    style={{ width: '80%', marginBottom: 50 }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Questo campo è obbligatorio',
                                        },
                                    ]}
                                >
                                    <Input type="number" autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                </Form.Item>
                                {regola.etichetta_conferma != null &&
                                    <Form.Item
                                        name={`${regola.campo}Verifica`}
                                        key={`${regola.ordine}Verifica`}
                                        initialValue={regola.value != null ? regola.value : ""}
                                        label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', marginBottom: 20 }}>{regola.etichetta_conferma}</div>}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Questo campo è obbligatorio',
                                                type: 'number'
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value || getFieldValue(regola.campo) === value) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject(
                                                        new Error("I due campi non corrispondono")
                                                    );
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                    </Form.Item>
                                }
                            </>
                        }
                    </>
                );
            case "otp":
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <>
                                <Form.Item
                                    name={regola.campo}
                                    key={regola.ordine}
                                    label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium' }}>{regola.etichetta}</div>}
                                    initialValue={regola.value != null ? regola.value : ""}
                                    style={{ width: '80%', marginBottom: 50 }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Questo campo è obbligatorio',
                                        },
                                    ]}
                                >
                                    <OTPInput autoComplete={isTotem ? 'off' : 'on'} style={{ padding: 20, marginTop: 30, backgroundColor: 'transparent' }}
                                        inputStyles={{ fontSize: innerWidth < 500 ? 15 : 25, fontFamily: 'Poppins-Regular', border: 0, borderBottom: "1px solid #cbcbcb", width: innerWidth < 500 ? 25 : 50, height: innerWidth < 500 ? 25 : 50, borderColor: '#0061df' }}
                                        separator={<span>-</span>} autoFocus OTPLength={6} otpType="number" disabled={false} secure={false} />
                                </Form.Item>
                            </>
                        }
                    </>
                );
            case "radio":
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <Form.Item
                                name={regola.campo}
                                key={regola.ordine}
                                style={{ marginBottom: 50 }}
                                label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', width: '80%' }}>{regola.etichetta}</div>}
                                initialValue={regola.value != null ? regola.value : ""}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Questo campo è obbligatorio',
                                    },
                                ]}
                            >
                                <Radio.Group >
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>


                                        {regola.items.length > 0 && regola.items.map((item) => <Radio key={item.valore} value={item.valore}><div
                                            style={{ fontFamily: 'Poppins-Regular', fontSize: 18 }}>
                                            {item.etichetta}
                                        </div>  </Radio>)}
                                    </div>
                                </Radio.Group>
                            </Form.Item>
                        }
                    </>
                );
            case "checkbox":

                let checkedValue;
                if (regola.value != null && Array.isArray(regola.value)) {
                    checkedValue = regola.value.map((item) => {
                        return item.valore;
                    });
                    if (!JSON.parse(localStorage.getItem(regola.campo))) {
                        localStorage.setItem(regola.campo, JSON.stringify(regola.value))
                    }
                }

                const handleCheckbox = (value, campo, ckd, spec) => {
                    checkedValue = null;
                    let checkArr = JSON.parse(localStorage.getItem(campo));
                    if (!checkArr) {
                        localStorage.setItem(campo, JSON.stringify([]));
                        checkArr = [];
                    }
                    if (ckd) {
                        if (!checkArr.find(e => e.valore == value)) {
                            const obj = {};
                            if (spec) {
                                obj.campo = spec[0].campo;
                                obj.id = campo + value
                                // obj[spec[0].campo] = 'valore inserito in input';
                            }
                            obj.valore = value;
                            checkArr.push(obj);
                        }
                    } else {
                        const index = checkArr.map(e => e.valore).indexOf(value);
                        if (index != -1) {
                            checkArr.splice(index, 1);
                        }
                    }
                    localStorage.setItem(campo, JSON.stringify(checkArr));
                    let newArr = checkbox;
                    newArr.push(campo);
                    setCheckbox(newArr);
                }

                const inputCheckboxHandler = (campo, valore) => {
                    document.getElementById(`check${campo}${valore}`).click();
                    document.getElementById(`check${campo}${valore}`).click();
                    // on change simulate click on the checkbox to uncheck and re check
                }

                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <Form.Item
                                name={regola.campo}
                                key={regola.ordine}
                                style={{ marginBottom: 50 }}
                                label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', width: '80%' }}>{regola.etichetta}</div>}
                            >
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    {regola.items.length > 0 && regola.items.map((item, i) => <Checkbox
                                        style={{ marginLeft: 0 }}
                                        key={i}
                                        id={`check${regola.campo}${item.valore}`}
                                        defaultChecked={regola.value && regola.value.find(e => e.valore == item.valore) ? true : false}
                                        onClick={(ckd) => handleCheckbox(item.valore, regola.campo, ckd.target.checked, item.items ? item.items : null)}>
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            <div style={{ fontSize: innerWidth < 500 ? 16 : 18, fontFamily: 'Poppins-Regular', }}> {item.etichetta}</div>
                                            {item.items &&
                                                <Form>
                                                    <Input autoComplete={isTotem ? 'off' : 'on'} id={regola.campo + item.valore}
                                                        defaultValue={regola.value && regola.value.find(e => e.valore == item.valore) ? regola.value.find(e => e.valore == item.valore).specifica : ''}
                                                        onChange={() => inputCheckboxHandler(regola.campo, item.valore)} placeholder={item.items[0].etichetta}
                                                        style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: 15, fontFamily: 'Poppins-Regular', width: '80%', marginLeft: 25, backgroundColor: 'transparent' }} />
                                                </Form>
                                            }
                                        </div>
                                    </Checkbox>)}
                                </div>
                            </Form.Item>
                        }
                    </>
                );
            case "date":
            case "date_enabled":
                const dateHandler = (date, dateString) => {
                    setPickedDate({ valore: dateString, campo: regola.campo })
                };
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <Form.Item
                                name={regola.campo}
                                key={regola.ordine}
                                label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium' }}>{regola.etichetta}</div>}
                                initialValue={regola.value != null ? regola.value : ""}
                                style={{ width: '80%', marginBottom: 50 }}
                                rules={[
                                    {
                                        required: regola.flg_not_required ? false : true,
                                        message: 'Questo campo è obbligatorio',
                                    },
                                    {
                                        pattern: new RegExp(/^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i),
                                        message: 'Inserisci una data valida',
                                    }
                                ]}
                            >
                                <Input autoComplete={isTotem ? 'off' : 'on'} disabled={regola.validazione == "date_enabled" ? false : regola.flg_readonly ? true : false} placeholder="GG/MM/AAAA" style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                            </Form.Item>
                            // <DatePicker  format="DD/MM/YYYY" onChange={dateHandler}/>
                        }
                    </>
                );
            case "combobox":
                const options = regola.items.length > 0 ? regola.items.map((item) => { return { label: item.etichetta, value: item.valore }; }) : []
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <Form.Item
                                name={regola.campo}
                                key={regola.ordine}
                                style={{ width: '80%', marginBottom: 50 }}
                                label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium' }}>{regola.etichetta}</div>}
                                rules={[
                                    {
                                        required: true,
                                        message: 'Questo campo è obbligatorio',
                                    },
                                ]}
                                initialValue={regola.value != null ? regola.value : ""}
                            >
                                <Select
                                    placeholder="Seleziona una campo"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                    showSearch
                                    style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular' }}
                                    options={options}
                                />
                            </Form.Item>
                        }
                    </>
                );
            case "api":

                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <div key={regola.ordine} style={{ marginTop: '-40px', marginBottom: '50px' }}>
                                <div style={{ color: 'black', fontSize: innerWidth < 500 ? 15 : 18, fontFamily: 'Poppins-Regular' }}
                                    dangerouslySetInnerHTML={{ __html: regola.etichetta }}
                                >
                                    {/* <div>
                                        <div style="font-family: 'Poppins-SemiBold', font-size: 18, color: '#707070', width: '80%', margin-bottom: 20 ">
                                            Procederemo ora alla verifica della tua identità.
                                        </div>
                                        <div style="font-family: 'Poppins-Regular', font-size: 16, color: '#707070', width: '80%' ">
                                            <ul>
                                                <li>
                                                    Tieni a portata di mano un documento di identità (Carta d’Identità, Patente di Guida...);
                                                </li>
                                                <li>
                                                    Assiciurati che il tuo documento di identità sia valido e privo di qualsiasi pellicola protettiva o impurità;
                                                </li>
                                                <li>
                                                    Ricordati di consentire l’accesso alla camera del dispositivo se ti verrà richiesto.
                                                </li>
                                            </ul>
                                        </div>
                                        <div style="font-family: 'Poppins-Regular', font-size: 16, color: '#707070', width: '80%', margin-bottom: 20 ">
                                            Il processo di verifica durerà pochi minuti e puoi effettuarlo direttamente dal tuo cellulare o se preferisci sul tuo pc personale.
                                            <div style="margin-top:10, margin-bottom:10">
                                                Effettua la verifica con il tuo cellulare
                                                Cliccando su “VERIFICA TRAMITE CELLULARE” riceverai un SMS contente un link per avviare il processo di verifica.
                                            </div> 
                                            Oppure clicca su “Continua” e procedi con la verifica della tua identità su questo dispositivo.
                                        </div>
                                    </div> */}
                                </div>
                                <div style={{ marginTop: 10, width: '80%', display: 'flex', justifyContent: 'center', marginBottom: '3vh' }}>
                                    {regola.items && regola.items.length > 0 && regola.items.map((item, index) => <div>
                                        <div key={index} hidden>
                                            <Form.Item
                                                name={regola.campo}
                                                key={regola.ordine}
                                                id={regola.campo}
                                                // value={caseApiValue}
                                                initialValue={0}
                                            ></Form.Item>
                                        </div>
                                        {item.testo && <Button type="primary" htmlType="submit" onClick={() => {
                                            // chiamata per fare chiamata dinamica
                                            // const token = localStorage.getItem('token');
                                            // const idPratica = localStorage.getItem('id_pratica');
                                            const v = {
                                                value: 1,
                                                nomeCampo: regola.campo
                                            };
                                            setCaseApiValue(v);
                                            // if (item.metodo == 'POST') {
                                            //     // chiamata post
                                            //     const data = {
                                            //         id_pratica: idPratica
                                            //     }
                                            //     setLoadingApi(true);
                                            //     postDinamico(data, token, item.url)
                                            //         .then((response) => {
                                            //             if (response) {
                                            //                 message.success('Operazione avvenuta correttamente');
                                            //             }
                                            //         })
                                            //         .catch((error) => {
                                            //             if (error) {
                                            //                 console.log(error);
                                            //                 message.error(error);
                                            //             }
                                            //         })
                                            //         .finally(() => {
                                            //             setLoadingApi(false);
                                            //         });
                                            // } else if (item.metodo == 'GET') {
                                            //     // chiamata get
                                            //     const data = {
                                            //         id_pratica: idPratica
                                            //     }
                                            //     setLoadingApi(true);
                                            //     getDinamico(data, token, item.url)
                                            //         .then((response) => {
                                            //             if (response) {
                                            //                 message.success('Operazione avvenuta correttamente');
                                            //             }
                                            //         })
                                            //         .catch((error) => {
                                            //             if (error) {
                                            //                 console.log(error);
                                            //                 message.error(error);
                                            //             }
                                            //         })
                                            //         .finally(() => {
                                            //             setLoadingApi(false);
                                            //         });
                                            // }
                                        }}
                                            style={{
                                                backgroundColor: '#2574F2', height: innerWidth < 500 ? 35 : 40, minWidth: 60, borderRadius: 6,
                                                zIndex: 10, fontSize: 14, display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: 'Poppins-Medium'
                                            }}>
                                            {loadingApi ? (
                                                <div style={{ padding: 10 }}>
                                                    <LoadingOutlined style={{ fontSize: "18px", color: "white" }} />
                                                </div>
                                            ) : (
                                                <span>
                                                    {item.testo}
                                                </span>

                                            )}

                                        </Button>}


                                    </div>)}
                                </div>
                            </div>

                        }
                    </>
                );
            case "html":
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <div key={regola.ordine} style={{ marginTop: '-20px', marginBottom: '50px' }}>
                                <div style={{ color: 'black', fontSize: innerWidth < 500 ? 15 : 18, fontFamily: 'Poppins-Regular' }}
                                    dangerouslySetInnerHTML={{ __html: regola.etichetta }}
                                >
                                </div>
                            </div>
                        }
                    </>
                );
            case "buttons":
                return (
                    <Form.Item
                        name={regola.campo}
                        key={regola.ordine}
                        label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium' }}>{regola.etichetta}</div>}
                    >
                        {!loadingSetSezioni &&
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                {regola.items && regola.items.map((item) => <div key={item.valore} style={{ padding: 10 }}>
                                    <Button key={item.valore} value={item.valore} type="primary" htmlType="submit" onClick={() => { setButtons({ valore: item.valore, campo: regola.campo }); }}
                                        style={{ height: innerWidth < 500 ? 35 : 50 }}>
                                        <div
                                            style={{ fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 15 : 23 }}>
                                            {item.etichetta}
                                        </div>

                                    </Button>
                                </div>)
                                }
                            </div>
                        }
                        {loadingSetSezioni &&
                            <div style={{ padding: 20 }}>
                                <LoadingOutlined style={{ fontSize: "22px", color: "#023AAE" }} />
                            </div>
                        }
                    </Form.Item>
                );
            case "checkbox-panel":
                const checkPanelHandler = (e) => {
                    const v = {};
                    v[regola.campo] = e.target.checked ? 1 : 0;
                    formRef.current.setFieldsValue(v);
                };

                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <>
                                <div key={regola.ordine} style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', marginBottom: 10 }}>
                                    {regola.etichetta}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Checkbox defaultChecked={regola.value} onChange={checkPanelHandler} style={{ marginRight: 20, marginTop: 2 }} />
                                    <div hidden >
                                        <Form.Item
                                            name={regola.campo}
                                            key={regola.ordine}
                                            // label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', marginBottom: 20 }}>{regola.etichetta_conferma}</div>}
                                            id={regola.campo}
                                            initialValue={regola.value}
                                        >
                                            <Input />
                                        </Form.Item>
                                    </div>
                                    <div style={{ fontFamily: 'Poppins-Light', fontSize: 16, marginBottom: 30, width: '80%' }} dangerouslySetInnerHTML={{ __html: regola.items.html }}></div>
                                </div>



                            </>
                        }
                    </>
                );
            case "upload":
                // const beforeUpload = (file) => {
                //     console.log('before upload');

                //     try {
                //         fileUpload.push(file);
                //         setFileUpload(fileUpload);
                //         //  setFileUpload([...fileUpload, file]);
                //     } catch (error) {
                //         console.log(error);
                //     }


                // };

                // const handleChange = (info) => {
                //     if (info.file.status === 'uploading') {
                //         info.file.status = 'done';
                //         return;
                //     }
                // };

                const preventUpload = () => {
                }

                const handleChange = (event) => {
                    setFileUpload([...event.target.files]);
                };

                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <Form.Item
                                name={regola.campo}
                                key={regola.ordine}
                                style={{ width: '80%', marginBottom: 50 }}
                                label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium', marginBottom: 10 }}>{regola.etichetta}</div>}
                                initialValue={regola.value != null ? regola.value : ""}
                            >


                                <input
                                    autoComplete={isTotem ? 'off' : 'on'}
                                    hidden
                                    id="files-onboarding"
                                    multiple
                                    name="upload"
                                    type="file"
                                    accept=".pdf, .jpg, .jpeg, .png"
                                    onChange={handleChange} />
                                <Button onClick={() => {
                                    document.getElementById('files-onboarding').click();
                                }} icon={<UploadOutlined style={{ fontSize: 22, marginRight: 10 }} />}
                                    style={{ width: 200, height: 60, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div style={{ fontSize: 18, fontFamily: 'Poppins-Regular' }}>Upload</div>
                                </Button>
                                <ul style={{ marginTop: '30px', marginLeft: '-30px' }}>
                                    {fileUpload && fileUpload.map((item, index) => <li key={index} style={{ margin: '5px', fontFamily: 'Poppins-Regular', fontSize: '14px' }}>
                                        {item.name}
                                    </li>)}
                                </ul>

                                {/* <Upload
                                    name="upload"
                                    accept=".pdf, .jpg, .jpeg, .png"
                                    maxCount={2}
                                    showUploadList={true}
                                    // beforeUpload={beforeUpload}
                                    onChange={handleChange}
                                    onDrop={handleChange}
                                    customRequest={preventUpload}
                                >
                                    <input type="file"/>
                                    <Button icon={<UploadOutlined style={{ fontSize: 22, marginRight: 10 }} />}
                                        style={{ width: 200, height: 60, display: 'flex', justifyContent: 'center', alignItems: 'center' }}><div style={{ fontSize: 18, fontFamily: 'Poppins-Regular' }}>Upload</div>
                                        </Button>
                                </Upload> */}

                            </Form.Item>
                        }
                    </>
                );
            case "maps":
                if ((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) {
                    localStorage.setItem('campo_map', regola.campo);
                } else {
                    localStorage.removeItem('campo_map', regola.campo);
                }
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <div>
                                <div >
                                    <LoadScript
                                        googleMapsApiKey={CONFIG.GOOGLE_MAPS_API_KEY}
                                        libraries={["places"]}
                                    >
                                        <SearchMap setCoord={setCoord} setLocationFields={setLocationFields} />
                                        <div style={{ marginBottom: 40 }} />
                                        <GoogleMap
                                            mapContainerStyle={{
                                                width: '100%',
                                                height: '400px'
                                            }}
                                            center={center}
                                            zoom={14}
                                        >
                                            <MarkerF position={coord} />
                                        </GoogleMap>
                                        <div style={{ marginBottom: 40 }} />
                                    </LoadScript>
                                </div>
                                {((locationFields.length > 0) || (regola.value && regola.value.indirizzo)) &&
                                    <div>
                                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                                            <Form.Item
                                                name="indirizzo"
                                                label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Medium' }}>Via</div>}
                                                id="indirizzo"
                                                style={{ marginBottom: 50, width: '80%' }}
                                                initialValue={regola.value ? regola.value.indirizzo : ""}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Questo campo è obbligatorio',
                                                    },
                                                ]}
                                            >
                                                <Input autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                            </Form.Item>
                                            <Form.Item
                                                name="civico"
                                                label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Medium' }}>Civico</div>}
                                                // label="Civico"
                                                id="civico"
                                                style={{ marginBottom: 50, marginLeft: 30, width: innerWidth < 500 ? '16%' : '15%' }}
                                                initialValue={regola.value ? regola.value.civico : ""}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Questo campo è obbligatorio',
                                                    },
                                                ]}
                                            >
                                                <Input autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                            </Form.Item>
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                                            <Form.Item
                                                name="provincia"
                                                // label="Provincia"
                                                label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Medium' }}>Provincia</div>}
                                                id="provincia"
                                                style={{ marginBottom: 50, width: innerWidth < 500 ? '23%' : '25%' }}
                                                initialValue={regola.value ? regola.value.provincia : ""}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Questo campo è obbligatorio',
                                                    },
                                                ]}
                                            >
                                                <Input autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                            </Form.Item>
                                            <Form.Item
                                                name="citta"
                                                // label="Città"
                                                label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Medium' }}>Città</div>}
                                                id="citta"
                                                style={{ marginBottom: 50, marginLeft: innerWidth < 500 ? 20 : 30, width: '50%' }}
                                                initialValue={regola.value ? regola.value.citta : ""}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Questo campo è obbligatorio',
                                                    },
                                                ]}
                                            >
                                                <Input autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                            </Form.Item>
                                            <Form.Item
                                                name="cap"
                                                // label="CAP"
                                                label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Medium' }}>CAP</div>}
                                                id="cap"
                                                style={{ marginBottom: 50, marginLeft: innerWidth < 500 ? 20 : 30, width: '25%' }}
                                                initialValue={regola.value ? regola.value.cap : ""}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Questo campo è obbligatorio',
                                                    },
                                                ]}
                                            >
                                                <Input autoComplete={isTotem ? 'off' : 'on'} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                            </Form.Item>
                                        </div>
                                        <div hidden>
                                            <Form.Item
                                                name="lat"
                                                id="lat"
                                            >
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                name="lng"
                                                id="lng"
                                            >
                                                <Input />
                                            </Form.Item>
                                        </div>
                                    </div>
                                }

                            </div>
                        }
                    </>
                );
            case "inventia":
                return (
                    <>
                        <WidgetInventia externalId={regola.items.externalId} sessionId={regola.items.sessionId} setHideButton={setHideButton} sezioneHandler={sezioneHandler} />
                        <div hidden>
                            <Form.Item
                                name="sessionId"
                                id="sessionId"
                                initialValue={regola.items.sessionId}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="externalId"
                                id="externalId"
                                initialValue={regola.items.externalId}
                            >
                                <Input />
                            </Form.Item>
                        </div>
                    </>
                );
            case "cards":
                let selected = false;
                const cardHandler = (valore) => {
                    const v = {};
                    v[regola.campo] = valore ? valore : null;
                    formRef.current.setFieldsValue(v);
                    setCardColor({ 'nome campo': valore });
                    const c = { ...cardColor };
                    c[regola.campo] = valore;
                    setCardColor(c);
                };
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <div>
                                <div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 16 : 20, fontFamily: 'Poppins-Medium' }}>{regola.etichetta}</div>
                                <div style={{
                                    display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    {regola.items.map((item, index) => <Card
                                        key={index}
                                        cover={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}><img
                                            style={{ height: 180, paddingTop: 20 }}
                                            alt="documento d'identità"
                                            src={item.valore == 1 ? CIE3 : item.valore == 2 ? CIE : item.valore == 3 ? pat : item.valore == 4 ? CI : item.valore == 5 ? pass : null}
                                        /></div>}
                                        // headStyle={{
                                        //     backgroundColor: cardColor[regola.campo] == item.valore ? '#106BE9' : 'white',
                                        //     color: cardColor[regola.campo] == item.valore ? '#106BE9' : 'white', borderTopLeftRadius: 20, borderTopRightRadius: 20
                                        // }}
                                        // title={SvgCie3}
                                        // key={item.valore}
                                        id={`card${regola.campo}${item.valore}`}
                                        onClick={() => cardHandler(item.valore)}
                                        bordered
                                        style={{
                                            cursor: 'pointer',
                                            margin: 20,
                                            width: 180,
                                            height: 300,
                                            borderRadius: 20,
                                            border: cardColor[regola.campo] == item.valore ? '2px solid #106BE9' : '2px solid #f0f0f0'
                                        }}
                                    >
                                        <p style={{ fontSize: 16, fontFamily: 'Poppins-Medium', textAlign: 'center' }}>{item.etichetta}</p>
                                    </Card>
                                    )
                                    }
                                </div>
                                <div hidden>
                                    <Form.Item
                                        name={regola.campo}
                                        key={regola.ordine}
                                        id={regola.campo}
                                        initialValue={regola.value}
                                    >
                                        <Input />
                                    </Form.Item>
                                </div>

                            </div>
                        }
                    </>
                );
            case "cards_horizontal":
                let selectedH = false;
                const cardHandlerH = (valore) => {
                    const v = {};
                    v[regola.campo] = valore ? valore : null;
                    formRef.current.setFieldsValue(v);
                    setCardColor({ 'nome campo': valore });
                    const c = { ...cardColor };
                    c[regola.campo] = valore;
                    setCardColor(c);
                };
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <div>
                                <div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 16 : 20, fontFamily: 'Poppins-Medium' }}>{regola.etichetta}</div>
                                <div style={{
                                    display: 'flex', flexDirection: 'column', flexWrap: 'wrap', width: '100%', justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    {regola.items.map((item, index) => <Card
                                        key={index}
                                        headStyle={{
                                            backgroundColor: cardColor[regola.campo] == item.valore ? '#106BE9' : 'white',
                                            color: cardColor[regola.campo] == item.valore ? '#106BE9' : 'white', borderTopLeftRadius: 20, borderTopRightRadius: 20
                                        }}
                                        id={`card${regola.campo}${item.valore}`}
                                        onClick={() => cardHandlerH(item.valore)}
                                        bordered
                                        style={{
                                            cursor: 'pointer',
                                            margin: 20,
                                            width: '60%',
                                            borderRadius: 20,
                                            border: cardColor[regola.campo] == item.valore ? '2px solid #106BE9' : '2px solid #f0f0f0'
                                        }}
                                    >
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1 }}>
                                                {
                                                    item.icon &&
                                                    <div style={{ paddingRight: 40 }}>
                                                        <div dangerouslySetInnerHTML={{ __html: item.icon }} />
                                                    </div>
                                                }
                                                <p style={{ flex: 1, fontSize: 16, fontFamily: 'Poppins-Medium', marginBottom: 0 }}>{item.etichetta}</p>
                                            </div>
                                            {
                                                item.descrizione &&
                                                <p style={{ flex: 1, fontSize: 14, fontFamily: 'Poppins-Regular', marginBottom: 0 }}>{item.descrizione}</p>
                                            }


                                        </div>

                                    </Card>
                                    )
                                    }
                                </div>
                                <div hidden>
                                    <Form.Item
                                        name={regola.campo}
                                        key={regola.ordine}
                                        id={regola.campo}
                                        initialValue={regola.value}
                                    >
                                        <Input />
                                    </Form.Item>
                                </div>

                            </div>
                        }
                    </>
                );
            case "search_field":
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Form.Item
                                    name={regola.campo}
                                    key={regola.ordine}
                                    label={<div style={{ color: '#0A69E8', fontSize: innerWidth < 500 ? 17 : 20, fontFamily: 'Poppins-Medium' }}>{regola.etichetta}</div>}
                                    initialValue={regola.value != null ? regola.value : ""}
                                    style={{ flex: 1, marginBottom: 50 }}
                                >
                                    <Input placeholder={regola.items.placeholder ? regola.items.placeholder : ''} autoComplete={isTotem ? 'off' : 'on'} disabled={regola.flg_readonly ? true : false} style={{ borderWidth: 0, borderBottomWidth: 1, borderColor: '#0061DF', fontSize: innerWidth < 500 ? 15 : 20, fontFamily: 'Poppins-Regular', backgroundColor: 'transparent' }} />
                                </Form.Item>
                                <Form.Item
                                    style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginLeft: 30 }}
                                >
                                    <Button type="primary"
                                        onClick={() => {
                                            // setCaseApiValue();
                                            var val = formRef.current.getFieldValue(regola.campo)
                                            if (val) {
                                                handleSearch(regola, regola.items.searchUrl, val)
                                            }
                                        }}
                                        style={{ backgroundColor: '#2574F2', height: innerWidth < 500 ? 35 : 50, width: innerWidth < 500 ? 125 : 200, borderRadius: 6, zIndex: 10 }}>

                                        <div
                                            style={{ fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 15 : 20 }}>
                                            Cerca
                                        </div>

                                    </Button>
                                </Form.Item>
                            </div>
                        }
                    </>
                );
            case "container_searched_value":
                let searchedHandler = (valore) => {
                    const v = {};
                    v[regola.campo] = valore ? valore : null;
                    formRef.current.setFieldsValue(v);
                    setCardColor({ 'nome campo': valore });
                    const c = { ...cardColor };
                    c[regola.campo] = valore;
                    setCardColor(c);
                };
                return (
                    <>
                        {((!regola.campo_visibilita) || (visibilita && visibilita[regola.campo])) &&
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                {
                                    searchValues[regola.ordine] && searchValues[regola.ordine].map((searchedItem, searchedIndex) => {
                                        return <Card
                                            key={searchedIndex}
                                            headStyle={{
                                                backgroundColor: cardColor[regola.campo] == searchedItem.id ? '#106BE9' : 'white',
                                                color: cardColor[regola.campo] == searchedItem.id ? '#106BE9' : 'white', borderTopLeftRadius: 20, borderTopRightRadius: 20
                                            }}
                                            id={`card${regola.campo}${searchedItem.id}`}
                                            onClick={() => searchedHandler(searchedItem.id)}
                                            bordered
                                            style={{
                                                cursor: 'pointer',
                                                margin: 20,
                                                width: '100%',
                                                borderRadius: 20,
                                                border: cardColor[regola.campo] == searchedItem.id ? '2px solid #106BE9' : '2px solid #f0f0f0'
                                            }}
                                        >
                                            <p style={{ flex: 1, fontSize: 16, fontFamily: 'Poppins-Medium', marginBottom: 0 }}>{searchedItem.titolo}</p>
                                            <p style={{ flex: 1, fontSize: 14, fontFamily: 'Poppins-Regular', marginBottom: 0 }}>{searchedItem.descrizione}</p>
                                        </Card>

                                    })

                                }
                                <div hidden>
                                    <Form.Item
                                        name={regola.campo}
                                        key={regola.ordine}
                                        id={regola.campo}
                                        initialValue={regola.value}
                                    >
                                        <Input />
                                    </Form.Item>
                                </div>

                            </div>
                        }
                    </>
                );
            case "hidden":
                return <div hidden>
                    <Form.Item
                        name={regola.campo}
                        key={regola.ordine}
                        id={regola.campo}
                        initialValue={regola.value}
                    ></Form.Item>
                </div>;

        }
    }

    const items = generateItems();

    const changeHandler = (value) => {
        for (const c in condizione) {
            if (value[0].name[0] == c) {
                if (condizione[c].valore == value[0].value) {
                    const vis = visibilita;
                    vis[value[0].name[0]] = true;
                    const v = { ...visibilita };
                    v[condizione[c].campoVis] = true;
                    setVisibilita(v);
                } else {
                    const v = { ...visibilita };
                    v[condizione[c].campoVis] = false;
                    setVisibilita(v);
                }
            }
        }
    };

    const changeHandlerSearch = (value) => {
        for (const c in condizione) {
            if (value[c] != undefined) {
                if (condizione[c].valore == value[c]) {
                    const vis = visibilita;
                    vis[c] = true;
                    const v = { ...visibilita };
                    v[condizione[c].campoVis] = true;
                    setVisibilita(v);
                } else {
                    const v = { ...visibilita };
                    v[condizione[c].campoVis] = false;
                    setVisibilita(v);
                }
            }
        }
    };

    const handleSearch = (regola, url, value) => {
        const token = localStorage.getItem('token');
        let tmpArray = [
            ...searchValues
        ]
        searchValue(url, value, token)
            .then((res) => {
                console.log(regola)
                formRef.current.setFieldValue(regola.items.confirmedValue, true)
                changeHandlerSearch(formRef.current.getFieldsValue())

                tmpArray[regola.items.fullfiledValueOrdine] = res
                setSearchValues(tmpArray)

            })
            .catch((error) => {
                /* if (error == 'Non Autorizzato') {
                    navigate('/HomeScreen');
                } else if (error == 'EX') {
                    Modal.error({
                        title: 'Errore nella verifica dei dati',
                        content: 'Si prega di riprovare controllando che i dati inseriti siano corretti',
                        onOk: () => window.location.reload()
                    });
                } else if (error == 'PE') {
                    Modal.error({
                        title: 'Pratica In Corso',
                        content: 'E\' già presente una pratica in corso',
                        onOk: () => navigate('/HomeScreen')
                    });
                } else if (error == 'SMS_OK') {
                    // message.info('L\'SMS è stato inviato correttamente.');
                    fetchRegole();
                } else {
                    message.error(error);
                } */
                // console.log(error)
                formRef.current.setFieldValue(regola.items.confirmedValue, false)
                changeHandlerSearch(formRef.current.getFieldsValue())
                message.error(error);
            });
    }

    return (
        <div >
            {loading ? (
                <Skeleton active
                    style={{ width: '60%', paddingTop: '15%' }} />
            ) : (
                <div  >
                    <div style={{ width: innerWidth < 1000 ? '90%' : '70%', paddingTop: '10%' }}
                    >
                        <div>
                            {/* <div style={{ color: '#003897', fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 26 : 40 }}>
                                {secondsTimeout} secondi
                            </div> */}
                            <div style={{ color: '#003897', fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 26 : 40 }}>
                                {headerSezione.etichetta}
                            </div>
                            <div style={{ color: '#003897', fontFamily: 'Poppins-Regular', fontSize: innerWidth < 500 ? 16 : 24 }}>
                                {headerSezione.sottotitolo}
                            </div>
                        </div>
                        <div style={{ marginTop: '18%' }}>
                            <Form layout="vertical" size="middle" onFinish={sezioneHandler}
                                onFieldsChange={changeHandler}
                                requiredMark={false}
                                style={{ width: '100%', marginBottom: 150 }}
                                ref={formRef}
                            >
                                {regole &&
                                    <div>
                                        {items}
                                    </div>
                                }
                                {!hideButton &&
                                    <Form.Item
                                        style={{ position: 'fixed', right: '8%', bottom: 50, zIndex: 10 }}
                                    >
                                        <Button type="primary" htmlType="submit"
                                            id="pol-confirm-onboarding"
                                            onClick={() => {
                                                setCaseApiValue();
                                            }}
                                            style={{ backgroundColor: '#2574F2', height: innerWidth < 500 ? 35 : 50, width: innerWidth < 500 ? 125 : 200, borderRadius: 6, zIndex: 10 }}>
                                            {!loadingSetSezioni &&
                                                <div
                                                    style={{ fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 15 : 20 }}>
                                                    CONTINUA
                                                </div>
                                            }
                                            {loadingSetSezioni &&
                                                <div>
                                                    <LoadingOutlined style={{ fontSize: "24px", color: "white" }} />
                                                </div>
                                            }
                                        </Button>
                                    </Form.Item>
                                }
                            </Form>
                        </div>
                    </div>
                </div>
            )
            }
            <DialogInattività showDialogInattivita={showDialogInattivita} setShowDialogInattivita={setShowDialogInattivita} secondsTimeout={secondsTimeout} setSecondsTimeout={setSecondsTimeout} />
        </div>
    );
};

export default FormOnboarding;
